import {Injectable, Injector} from '@angular/core';
import {Observable, Observer} from 'rxjs';
import {RemoteCallCommonService} from './remote-call-common.service';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';

import {ModalWindowService} from '../modal-window/modal-window.service';

/*
    esta capa elimina los errores de Http
    NO elimina los errores devueltos por la petición en sí
*/

@Injectable({
    providedIn: 'root'
})
export abstract class TableAbstractService {
    private _RemoteCallCommonS: RemoteCallCommonService;
    private _ModalWindowS:  ModalWindowService;

    // ---------------------------------------------------------------------------
    get url_base(): string {
        return this._RemoteCallCommonS.url_base;
    }

    // ===========================================================================
    // ---------------------------------------------------------------------------
    constructor(protected Injector: Injector) {
        const http = this.Injector.get(HttpClient);
        this._ModalWindowS = this.Injector.get(ModalWindowService);

        this._RemoteCallCommonS = new RemoteCallCommonService(http);
    }


    // ---------------------------------------------------------------------------
    public changeURLBase(new_url: string): void {
        this._RemoteCallCommonS.url_base = new_url;
    }

    // ---------------------------------------------------------------------------
    public restoreDefaultURLBase(): void {
        this._RemoteCallCommonS.url_base = this._RemoteCallCommonS.url_base_default;
    }

    // ===========================================================================
    // ---------------------------------------------------------------------------
    // Send a request to server.
    // Send as GET
    // ---------------------------------------------------------------------------
    public requestToServerGet(endpoint: string, filters?: object | null): Observable<any> {


        // return this._RemoteCallCommonS.readGet(endpoint, filters);
        return new Observable((observer: Observer<any>) => {
            this._RemoteCallCommonS.readGet(endpoint, filters).subscribe(
                (read_data: any) => {
                    observer.next(read_data)
                },
                (error: HttpErrorResponse) => {
                    this._ModalWindowS.showMessageError(error.message);
                    observer.error(error);
                },
                () => {
                    observer.complete()
                }
            );
        });

    }

    // ---------------------------------------------------------------------------
    // Send a request to server.
    // Send as POST
    // ---------------------------------------------------------------------------
    // request as form data
    public requestToServerPost(endpoint: string, filters?: object | null): Observable<any> {

        // return this._RemoteCallCommonS.readPost(endpoint, filters);
        return new Observable((observer: Observer<any>) => {
            this._RemoteCallCommonS.readPost(endpoint, filters).subscribe(
                (read_data: any) => {
                    observer.next(read_data)
                },
                (error: HttpErrorResponse) => {
                    this._ModalWindowS.showMessageError(error.message);
                    observer.error(error);
                },
                () => {
                    observer.complete()
                }
            );
        });

    }

    // ---------------------------------------------------------------------------
    // request as JSON object
    public requestToServerPostJSON(endpoint: string, filters?: object | null): Observable<any> {

        // return this._RemoteCallCommonS.readPostJSON(endpoint, filters);
        return new Observable((observer: Observer<any>) => {
            this._RemoteCallCommonS.readPostJSON(endpoint, filters).subscribe(
                (read_data: any) => {
                    observer.next(read_data)
                },
                (error: HttpErrorResponse) => {
                    // this._ModalWindowS.showMessageError(error.message);
                    observer.error(error)
                },
                () => {
                    observer.complete()
                }
            );
        });

    }

    // ---------------------------------------------------------------------------
    // Send data to server to be saved.
    // Always send as POST
    // ---------------------------------------------------------------------------
    // send as form data
    public sendToServer(endpoint: string, data_to_send?: object): Observable<any> {

        // return this._RemoteCallCommonS.write(endpoint, data_to_send);
        return new Observable((observer: Observer<any>) => {
            this._RemoteCallCommonS.write(endpoint, data_to_send).subscribe(
                (read_data: any) => {
                    observer.next(read_data)
                },
                (error: HttpErrorResponse) => {
                    this._ModalWindowS.showMessageError(error.message);
                    observer.error(error)
                },
                () => {
                    observer.complete()
                }
            );
        });
        

    }

    // ---------------------------------------------------------------------------
    // send as JSON object
    public sendToServerJSON(endpoint: string, data_to_send?: object): Observable<any> {

        // return this._RemoteCallCommonS.writeJSON(endpoint, data_to_send);
        return new Observable((observer: Observer<any>) => {
            this._RemoteCallCommonS.write(endpoint, data_to_send).subscribe(
                (read_data: any) => {
                    observer.next(read_data)
                },
                (error: HttpErrorResponse) => {
                    this._ModalWindowS.showMessageError(error.message);
                    observer.error(error)
                },
                () => {
                    observer.complete()
                }
            );
        });

    }

}
